export const BASE64_PREFIX = 'base64,';
